import Config from "../types/ocm.type";

declare const ocm: Config | undefined;

export const country = ocm?.config?.country || "de";
export const language = ocm?.config?.language || "de";
export const contextPath = ocm?.config?.encodedContextPath ?? `/${country}-de/shop`;
export const isClassicSite = ocm?.isClassicSite ?? false;
export const shopContextPath = isClassicSite ? `/${country}-de/shop` : contextPath;

// Epoq
export const isEpoqRecosCartEnabled = ocm?.config?.isEpoqRecosCartEnabled;
export const epoqRecosPlpChunkSize = ocm?.config?.epoqRecosPlpChunkSize;
export const is8SelectRecosPdpEnabled = ocm?.config?.is8SelectRecosPdpEnabled;
export const isEpoqRecosPdpEnabled = ocm?.config?.isEpoqRecosPdpEnabled;

// Contactcenter
export const captchaPublickey = ocm?.captchaOptions?.publickeyContactcenter || "";
export const captchaActive = ocm?.captchaOptions?.displayContactcenter;

// Department
type DepartmentType = "damen" | "herren" | "kinder";
export const department: DepartmentType | undefined = ocm?.config?.department as DepartmentType;

// Cart Payment Buttons ABC-Test
export const isPaymentButtonsStickyAnchorButton = ocm?.config?.isPaymentButtonsStickyAnchorButton;
export const isPaymentButtonsNotSticky = ocm?.config?.isPaymentButtonsNotSticky;
export const isPaymentButtonsAllSticky = ocm?.config?.isPaymentButtonsAllSticky;

// PLP Show More Filters Button AB-Test
export const isDesktopMoreFilter = ocm?.config?.isDesktopMoreFilter;
